import styled from 'styled-components'

export const MathEssayInputWrapper = styled.div`
  max-width: 100%;
`
